import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check-circle",
  "use": "check-circle-usage",
  "viewBox": "0 0 517.91 517.91",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 517.91 517.91\" id=\"check-circle\"><title>Kreis-Haken</title><path d=\"M259 517.91A258.95 258.95 0 0 1 75.85 75.85a258.95 258.95 0 1 1 366.21 366.21A257.27 257.27 0 0 1 259 517.91zm0-512A253 253 0 0 0 80 437.88 253.06 253.06 0 1 0 437.88 80 251.39 251.39 0 0 0 259 5.91zm136.63 168.63a5.91 5.91 0 0 0-8.35-8.36L213.77 339.69l-68-52.52a5.91 5.91 0 0 0-7.22 9.35l76.17 58.88z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/check-circle.svg
// module id = 299
// module chunks = 6